import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  headerContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    position: 'sticky',
    zIndex: 99,
    top: 0,
  },
}))
